import { createApp } from 'vue';
import { createPinia } from 'pinia'
import '@/styles/scss/style.scss'
import '@/styles/scss/common.scss'
import { MathfieldElement } from "mathlive"
MathfieldElement.fontsDirectory = null
MathfieldElement.soundsDirectory = null
const MathLive = new MathfieldElement()
import App from '@/components/student/App.vue'
import router from '@/router/student'
import VueGtag from "vue-gtag";
import * as Sentry from "@sentry/vue";
import { isEnvCaptureGoogleAnalyticsEvents } from "@/util/env";
import ButtonBlue from "@/components/shared/ButtonBlue.vue";
import ButtonWhite from "@/components/shared/ButtonWhite.vue";
import ButtonReturn from "@/components/shared/ButtonReturn.vue";
import ButtonLogoutWhite from "@/components/shared/ButtonLogoutWhite.vue";
import ButtonLogoutBlue from "@/components/shared/ButtonLogoutBlue.vue";
import ButtonLogin from "@/components/shared/ButtonLogin.vue";
import ButtonArrowRight from "@/components/shared/ButtonArrowRight.vue";
import PopupModal from "@/components/shared/PopupModal.vue";
import FullScreenModal from "@/components/shared/FullScreenModal.vue";
import ProgressBar from "@/components/shared/ProgressBar.vue";
import ThreeStars from "@/components/shared/ThreeStars.vue";
import IconNotification from "@/components/shared/IconNotification.vue";
import ButtonGroup from "@/components/shared/ButtonGroup.vue";
import GlobalNavigation from "@/components/shared/GlobalNavigation.vue";
import StarMedal from "@/components/shared/StarMedal.vue";
import TextBookPageNumber from "@/components/shared/TextBookPageNumber.vue";
import Carousel from "@/components/shared/Carousel.vue";
import PopupBalloon from "@/components/shared/PopupBalloon.vue";
import DonutGraph from "@/components/shared/DonutGraph.vue";
import QuestionStatus from "@/components/shared/QuestionStatus.vue";
import QuestionInformation from "@/components/shared/QuestionInformation.vue";
import QuestionHelp from "@/components/shared/QuestionHelp.vue";
import QuestionCorrectWrong from "@/components/shared/QuestionCorrectWrong.vue";
import AnswerArea from "@/components/shared/AnswerArea.vue";
import QuizArea from "@/components/shared/QuizArea.vue";
import AnswerText from "@/components/shared/AnswerText.vue";
import AnswerPreSuffixText from "@/components/shared/AnswerPreSuffixText.vue";
import AnswerCheckbox from "@/components/shared/AnswerCheckbox.vue";
import AnswerRadioButton from "@/components/shared/AnswerRadioButton.vue";
import AnswerExplanation from "@/components/shared/AnswerExplanation.vue";
import AppLayout from "@/components/student/AppLayout.vue";
import AnswerSelect from "@/components/shared/AnswerSelect.vue";
import AnswerTextForGrading from "@/components/shared/AnswerTextForGrading.vue";
import AnswerTextVerifyGrading from "@/components/shared/AnswerTextVerifyGrading.vue";
import MarkdownView from "@/components/shared/MarkdownView.vue";
import WorkAccordion from "@/components/shared/WorkAccordion.vue";
import ChapterAccordion from "@/components/shared/ChapterAccordion.vue";
import MissionTab from "@/components/shared/MissionTab.vue";
import VirtualKeyboard from "@/components/shared/VirtualKeyboard.vue";
import ErrorReportModal from "@/components/shared/ErrorReportModal.vue";
import HomeworkList from "@/components/shared/HomeworkList.vue";
import Homework from "@/components/student/Homework.vue";
import LoadingPage from "@/components/shared/LoadingPage.vue";
import MarkdownRenderer from "@/components/shared/MarkdownRenderer"
import ZoomableImage from "@/components/shared/ZoomableImage.vue"
import ReadingModal from './components/shared/ReadingModal.vue';
import ErrorModal from './components/shared/ErrorModal.vue';
import FigureBarHorizontal from '@/components/shared/FigureBarHorizontal.vue';

// create a vue3 app instance
const app = createApp(App)
// enabled vue devtools on browser
// app.config.performance = true
// register available component 
app
  .component('app-layout', AppLayout)
  .component('button-login', ButtonLogin)
  .component('button-blue', ButtonBlue)
  .component('button-white', ButtonWhite)
  .component('button-return', ButtonReturn)
  .component('button-logout-white', ButtonLogoutWhite)
  .component('button-logout-blue', ButtonLogoutBlue)
  .component('button-arrow-right', ButtonArrowRight)
  .component('button-group', ButtonGroup)
  .component('popup-modal', PopupModal)
  .component('full-screen-modal', FullScreenModal)
  .component('global-navigation', GlobalNavigation)
  .component('icon-notification', IconNotification)
  .component('mission-tab', MissionTab)
  .component('progress-bar', ProgressBar)
  .component('three-stars', ThreeStars)
  .component('star-medal', StarMedal)
  .component('carousel', Carousel)
  .component('popup-balloon', PopupBalloon)
  .component('donut-graph', DonutGraph)
  .component('markdown-renderer', MarkdownRenderer)
  .component('zoomable-image', ZoomableImage)
  .component('markdown-view', MarkdownView)
  .component('work-accordion', WorkAccordion)
  .component('chapter-accordion', ChapterAccordion)
  .component('loading-page', LoadingPage)
  .component('homework', Homework)
  .component('homework-list', HomeworkList)
  .component('error-report-modal', ErrorReportModal)
  .component('textbook-page-number', TextBookPageNumber)
  .component('question-status', QuestionStatus)
  .component('question-information', QuestionInformation)
  .component('question-help', QuestionHelp)
  .component('question-correct-wrong', QuestionCorrectWrong)
  .component('answer-area', AnswerArea)
  .component('quiz-area', QuizArea)
  .component('answer-text', AnswerText)
  .component('answer-pre-suffix-text', AnswerPreSuffixText)
  .component('answer-checkbox', AnswerCheckbox)
  .component('answer-radio-button', AnswerRadioButton)
  .component('answer-explanation', AnswerExplanation)
  .component('answer-text-for-grading', AnswerTextForGrading)
  .component('answer-text-verify-grading', AnswerTextVerifyGrading)
  .component('virtual-keyboard', VirtualKeyboard)
  .component('answer-select', AnswerSelect)
  .component('reading-modal', ReadingModal)
  .component('error-modal', ErrorModal)
  .component('figure-bar-horizontal', FigureBarHorizontal)

// vue-gtag for google analytic, disabled for development, analytic_d="G-PM8KGJMFXC"
// app.use(VueGtag, {
//   config: { id: "google analytic id" }
// }, router);
if (isEnvCaptureGoogleAnalyticsEvents()){
  app.use(VueGtag, {
    config: { 
      id: import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID_FRONTEND,
      params: {
        transport_type: "beacon"
      } 
    }
  }, router);

  /*
   * Setup Sentry
   */
  Sentry.init({
    app: app,
    release: import.meta.env.VITE_FRONTEND_APP_VERSION, // for match source-map
    dsn: import.meta.env.VITE_SENTRY_DSN_FRONTEND,
    integrations: [new Sentry.BrowserTracing()],
    ignoreErrors: [
        'ResizeObserver loop limit exceeded', // NFR-2688
        'Request failed with status code 403', // NFR-2939
        'Network Error',  // NFR-3137
        'InvalidStateError: Failed to start the audio device',  // NFR-2943
        "null is not an object (evaluating 'elt.parentNode')", // NFR-3668
        'window.onorientationchange is not a function.', // NFR-3668
    ],
    beforeSend(event, hint){
        const error:any = hint.originalException;
        if(
            error &&
            error.message &&
            (
                error.message.match(/navigation cancelled/i) ||
                error.message.match(/redundant navigation/i) ||
                error.message.match(/redirected/i) ||
                error.message.match(/duplicated/i) ||
                error.message.match(/aborted/i) ||
                error.message.match(/Network request failed/i) ||
                error.message.match(/Invalid font data in ArrayBuffer/i) ||
                error.message.match(/removeAllHighlightsForSB/i)  // NFR-3985
            )
        ){
            return null
        }
        return event
    },
    // FIXME: サンプリングレートは1.0で100%, 要調整
    tracesSampleRate: 0.1  // NFR-4616(make the rate 1.0 to 0 to avoid 429 too many request errors)
  });
}
// create pinia instance
const pinia = createPinia()
// register pinia store
app.use(pinia)
// register vue router
app.use(router)
// render vue component
app.mount("#app")
